import React from "react";
import MaterialTable, { MaterialTableProps, Column } from "material-table";
import { SimpleResource } from "rest-hooks";
import { Typography, Grid, makeStyles, Theme } from "@material-ui/core";
import { useCommonWidths } from "../../hooks";
import { defineMessages, injectIntl } from "react-intl";

interface MyPageDataTableDetailColumnProps extends Column<any> {
	value?: string | React.ReactNode;
	label?: string | React.ReactNode;
	hideIfCondition?: boolean;
	forMobile?: boolean;
}

interface MyPageDataTableProps extends MaterialTableProps<any> {
	data: SimpleResource[] | any; // Either list of objects, or detailed data about one object
	columns: MyPageDataTableDetailColumnProps[];
	limit?: number;
	intl: any;
}

const useStyles = makeStyles((theme: Theme) => ({
	detailRow: {
		borderBottom: "1px solid lightgrey",
		padding: "10px 0",
	},
	detailRowValue: {
		fontWeight: "bold",
	},
}));
const messages = defineMessages({
	noData: {
		id: "minside.datatable.no_data",
		defaultMessage: "Ingen data tilgjengelig",
		description: "No data in datatable",
	},
});

const MyPageDataTable = (props: MyPageDataTableProps) => {
	const { data, limit, options, ...rest } = props;

	if (!Array.isArray(data)) {
		return <DetailTable {...props} />;
	}

	const defaultOptions = {
		draggable: false,
		pageSize: 10,
		pageSizeOptions: [5, 10, 20],
		paging: !limit && data.length > 10,
		toolbar: false,
	};

	const tableOptions = { ...defaultOptions, ...options };

	return (
		<MaterialTable
			data={(limit && data.slice(0, limit)) || data}
			options={tableOptions}
			style={{ boxShadow: "none" }}
			localization={{
				body: {
					emptyDataSourceMessage: props.intl.formatMessage(messages.noData),
				},
			}}
			{...rest}
		/>
	);
};

const DetailTable = (props: MyPageDataTableProps) => {
	const { columns } = props;

	return (
		<Grid container>
			{columns.map((c, idx) => {
				return c.hideIfCondition ? null : (
					<DetailTableRow key={idx} label={c.label} value={c.value} />
				);
			})}
		</Grid>
	);
};

const DetailTableRow = (props: MyPageDataTableDetailColumnProps) => {
	const isMobile = useCommonWidths().isXsDown;
	const classes = useStyles();

	const { label, value } = props;

	return (
		<Grid
			item
			container
			direction={isMobile ? "column" : "row"}
			justify="space-between"
			className={classes.detailRow}
		>
			<Grid item>
				<Typography variant="subtitle1">{label}</Typography>
			</Grid>
			<Grid item>
				<Typography variant="subtitle1" className={classes.detailRowValue}>
					{value}
				</Typography>
			</Grid>
		</Grid>
	);
};

export default injectIntl(MyPageDataTable);
